// A finding's or a Risk's severity as a person reads it (#870): the scanner's word,
// capitalised, in its own tone. The wire value is unchanged.

/** The scanner's severities, worst first: the route's `severity` filter takes these. */
export const SEVERITY_LEVELS = ["critical", "high", "medium", "low", "informational"] as const;

/** Each severity's word and its tone's class (`.severity--<level>` in `styles/console.css`). */
const SEVERITY: Record<string, { word: string; className: string }> = {
  critical: { word: "Critical", className: "severity severity--critical" },
  high: { word: "High", className: "severity severity--high" },
  medium: { word: "Medium", className: "severity severity--medium" },
  low: { word: "Low", className: "severity severity--low" },
  informational: {
    word: "Informational",
    className: "severity severity--informational",
  },
};

/** The word for a severity; one the scale does not know is shown as it came. */
export const severityWord = (level: string): string => SEVERITY[level]?.word ?? level;

export function Severity({ level }: { level: string }) {
  return <span className={SEVERITY[level]?.className ?? "severity"}>{severityWord(level)}</span>;
}
